export function isAdministrator(roles)
	{
	if (!roles)
		return false;
	return (roles["System Administrator"]||roles["Administrator"]);
	}
	
export function isWorkflowEditor(roles)
	{
	/*{"System Administrator": true,"Administrator":0,"User Manager":true,"Workflow Manager":true,"Form manager":0}*/
	if (!roles)
		return false;
	return roles["Workflow Manager"]||isAdministrator(roles);
	}

export function isUserManager(roles)
	{
	/*{"System Administrator": true,"Administrator":0,"User Manager":true,"Workflow Manager":true,"Form manager":0}*/
	if (!roles)
		return false;
	return roles["User Manager"]||isAdministrator(roles);
	}

export function isFormManager(roles)
	{
	/*{"System Administrator": true,"Administrator":0,"User Manager":true,"Workflow Manager":true,"Form manager":0}*/
	if (!roles)
		return false;
	return roles["Form manager"]||isAdministrator(roles);
	}

